// DataTables server-side processing for a <table> rendered with:
//   data-url          - JSON endpoint (see app/lib/server_side_datatable.rb)
//   data-length-menu  - page length options, e.g. [10, 25, 50, 100]
//   <th data-column>  - column name in the JSON rows
//                       (add data-orderable="false" to make a column not sortable)
// Options:
//   renderers - { column: (row) => html } for columns with custom HTML (e.g. an edit link).
//               Everything else is rendered as escaped text.
//   ajaxData  - () => object of extra params sent with every request

export function escapeHtml(value) {
  return $.fn.dataTable.render.text().display(value);
}

export function initServerSideDataTable(table, { renderers = {}, ajaxData = () => ({}) } = {}) {
  if (!table || $.fn.DataTable.isDataTable(table)) {
    return;
  }

  const textRenderer = $.fn.dataTable.render.text();
  const columns = Array.from(table.querySelectorAll('thead th'), (th) => {
    const { column } = th.dataset;
    const render = renderers[column];

    if (render) {
      return { data: column, defaultContent: '', render: (_data, _type, row) => render(row) };
    }

    return { data: column, render: textRenderer };
  });

  $(table).DataTable({
    serverSide: true,
    ajax: {
      url: table.dataset.url,
      data: (params) => ({ ...params, ...ajaxData() }),
    },
    columns,
    order: [],
    lengthMenu: JSON.parse(table.dataset.lengthMenu),
    searchDelay: 400,
    language: {
      emptyTable: 'ไม่พบข้อมูล',
      zeroRecords: 'ไม่พบข้อมูล',
    },
  });

  document.addEventListener(
    'turbo:before-cache',
    () => {
      if ($.fn.DataTable.isDataTable(table)) {
        $(table).DataTable().destroy();
      }
    },
    { once: true },
  );
}
